module.exports = __webpack_public_path__ + "img/zanwu.d29f9545.png";